import { render, staticRenderFns } from "./MachinePermission.vue?vue&type=template&id=600d3033&scoped=true"
import script from "./MachinePermission.vue?vue&type=script&lang=js"
export * from "./MachinePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d3033",
  null
  
)

export default component.exports